export const BETSLIP_STATUSES = {
    PENDING: 1,
    SUCCEED: 2,
    FAILED: 4,
    PROCESSING: 8,
}